var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87932 20.8621C-0.807096 16.1737 -0.807096 8.57284 3.87932 3.88447C8.56575 -0.80391 16.1635 -0.80391 20.8499 3.88447C25.5355 8.572 25.5363 16.1737 20.8499 20.8621C16.1635 25.5505 8.5649 25.5496 3.87932 20.8621ZM5.57638 19.1644C7.37673 20.9655 9.81853 21.9773 12.3646 21.9773C14.9107 21.9773 17.3525 20.9655 19.1528 19.1644C20.9532 17.3632 21.9646 14.9204 21.9646 12.3733C21.9646 9.82615 20.9532 7.38333 19.1528 5.58223C17.3525 3.78113 14.9107 2.76928 12.3646 2.76928C9.81853 2.76928 7.37673 3.78113 5.57638 5.58223C3.77603 7.38333 2.76461 9.82615 2.76461 12.3733C2.76461 14.9204 3.77603 17.3632 5.57638 19.1644ZM5.66123 11.173L11.1648 11.173L11.1648 5.66712C11.1504 4.86662 11.55 4.4668 12.3646 4.4668C13.1792 4.4668 13.5788 4.86662 13.5644 5.66712V11.173L19.068 11.173C19.8673 11.173 20.2669 11.5728 20.2678 12.3733C20.2669 13.1738 19.8673 13.5736 19.068 13.5736L13.5644 13.5736V19.0795C13.5831 19.8791 13.1826 20.2798 12.3646 20.2798C11.5466 20.2798 11.1461 19.8791 11.1648 19.0795L11.1648 13.5736L5.66123 13.5736C4.86192 13.5753 4.46141 13.1746 4.46141 12.3733C4.46141 11.5719 4.86192 11.1713 5.66123 11.173Z",
    fill: "#011632"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.98ad61c7591a9a1957995154f2c005b1.svg";
export { ForwardRef as ReactComponent };